import { render, staticRenderFns } from "./CustomerSectionView.vue?vue&type=template&id=8af51f6c&scoped=true&"
import script from "./CustomerSectionView.vue?vue&type=script&lang=js&"
export * from "./CustomerSectionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af51f6c",
  null
  
)

export default component.exports